import React from 'react';
import { motion } from 'framer-motion';
import { FileText, BookOpen, Gavel, Target, Download, Zap } from 'lucide-react';
export const Included = () => {
  const items = [{
    icon: <FileText className="w-8 h-8 text-gold-500" data-id="element-145" />,
    title: 'Modelos de escritos',
    desc: 'Plantillas de amparos, medidas cautelares y cartas documento listas para completar con los datos de tu cliente y presentar.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-gold-500" data-id="element-146" />,
    title: 'Fundamentos legales',
    desc: 'Argumentación jurídica sólida y estructurada para rebatir las negativas más comunes de las empresas de medicina prepaga.'
  }, {
    icon: <Gavel className="w-8 h-8 text-gold-500" data-id="element-147" />,
    title: 'Jurisprudencia clave',
    desc: 'Selección de los fallos más relevantes y actualizados que respaldan el derecho a la salud integral.'
  }, {
    icon: <Target className="w-8 h-8 text-gold-500" data-id="element-148" />,
    title: 'Estrategias procesales',
    desc: 'Paso a paso táctico sobre cómo encarar el caso desde la primera consulta hasta la resolución favorable.'
  }, {
    icon: <Download className="w-8 h-8 text-gold-500" data-id="element-149" />,
    title: 'Material descargable',
    desc: 'Formato 100% digital en PDF. Descargalo en tu computadora, tablet o celular y llevalo siempre con vos.'
  }, {
    icon: <Zap className="w-8 h-8 text-gold-500" data-id="element-150" />,
    title: 'Acceso inmediato',
    desc: 'Una vez acreditado el pago, recibís el material al instante en tu correo para empezar a trabajar hoy mismo.'
  }];
  return <section className="py-20 bg-legal-900" data-id="element-151">
      <div className="container mx-auto px-4" data-id="element-152">
        <div className="text-center mb-16" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-154">
            ¿Qué incluye el tratado?
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-155">
            Todo lo que necesitás en un solo lugar.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-156">
          {items.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-legal-800 border border-legal-700 p-8 rounded-xl hover:border-gold-500/50 transition-colors group" data-id="element-157">
              <div className="mb-6 p-3 bg-legal-900 rounded-lg inline-block group-hover:scale-110 transition-transform" data-id="element-158">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-159">
                {item.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-160">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};